import { toResponseError, type ResponseSuccess, type RoleMemberAddInput, type TinyRole } from '@terros/common'
import { withRole } from '../user/listRoles'
import { useUserCache } from '../user'
import { useTantalimMutation } from '../mutation'
import { type AddHookResponse, mutationAdd } from '../hooks'
import { useRoleCache } from './cache'

export function useAddRoleMember(): AddHookResponse<RoleMemberAddInput, ResponseSuccess> {
  const cache = useRoleCache()
  const mutation = useTantalimMutation<RoleMemberAddInput, ResponseSuccess>({ url: '/role/member/add' })
  const profileCache = useUserCache()

  async function add(input: RoleMemberAddInput): Promise<ResponseSuccess> {
    try {
      const output = await mutation.mutateAsync(input)
      cache.clearItem(input.roleId)
      profileCache.clearProfile(input.userId)
      const role = cache.findTinyRole(input.roleId)
      profileCache.syncListedRoles(input.userId, (roles): TinyRole[] => {
        if (!role) return roles
        return withRole(roles, role)
      })
      return output
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationAdd(mutation, add)
}
